"use client";

import { useCallback } from "react";
import { usePathname } from "next/navigation";

const with_slash = (path = "") => (path.endsWith("/") ? path : `${path}/`);

export default function useAnchorClick(on_click) {
    const pathname = usePathname() || "";

    return useCallback(
        (url) => (event) => {
            on_click?.();

            if (!url?.includes("#")) return;

            const [path, hash] = url.split("#");
            if (with_slash(path) !== with_slash(pathname)) return;

            const target = document.getElementById(hash);
            if (!target) return;

            event.preventDefault();
            target.scrollIntoView({ behavior: "smooth", block: "start" });
        },
        [pathname, on_click]
    );
}
